import { EDashboardSegmentKey } from './types/dashboard.types';

export const DASHBOARD_ENDPOINT = '/dashboard/td-items';
export const DASHBOARD_QUERY_KEY = 'dashboard';
export const DASHBOARD_QUERY_STALE_TIME_MS = 30_000;
export const DASHBOARD_ITEM_SEGMENTS_ID = 'dashboard-item-segments';

export const DEFAULT_DASHBOARD_SEGMENT_KEY = EDashboardSegmentKey.OPEN_APPROVAL;

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/dashboard/configs/dashboard.config.ts
export const DASHBOARD_DUE_SOON_LABEL = '60 days';
// The UI is one-based, so page 10,001 maps to the backend's zero-based page 10,000.
export const MAX_DASHBOARD_UI_PAGE = 10_001;
export const MAX_DASHBOARD_PAGE_SIZE = 100;

export const DASHBOARD_ROOT_IDS_PARAM = 'rootIds';
export const DASHBOARD_SEGMENT_PARAM = 'segment';
